import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

export const MUSIC_APPRECIATION = 'musicappreciation';
export const CELEBRITY = 'celebrity';
export const GENRE = 'genre';

const cslExclusive24bit = true;

if (document.getElementById(MUSIC_APPRECIATION)) {
  ReactDOM.render(<App page={MUSIC_APPRECIATION} cslExclusive24bit={cslExclusive24bit} />, document.getElementById(MUSIC_APPRECIATION));
}

if (document.getElementById(CELEBRITY)) {
  ReactDOM.render(<App page={CELEBRITY} cslExclusive24bit={cslExclusive24bit} />, document.getElementById(CELEBRITY));
}

if (document.getElementById(GENRE)) {
  ReactDOM.render(<App page={GENRE} cslExclusive24bit={cslExclusive24bit} />, document.getElementById(GENRE));
}

if (document.getElementById('root') && process.env.NODE_ENV === 'development') {
  let path = MUSIC_APPRECIATION;
  if(window.location.href.indexOf(`/${CELEBRITY}`) !== -1) {
    path = CELEBRITY;
  } else if(window.location.href.indexOf(`/${GENRE}`) !== -1) {
    path = GENRE;
  }
  ReactDOM.render(<App page={path} cslExclusive24bit={cslExclusive24bit} />, document.getElementById('root'));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
